import {ApiOperationError} from '@di-nxt/resource-container/src/resources';
import {Dispatch} from 'redux';
import {t} from '../../../../localization';
import {uuidv4} from '../../../utils';
import {snackRedux} from '../../local';
import {EnhancedErrorHandler} from '../types';

export const onApiErrorShowSnack: EnhancedErrorHandler = (
  error: Error,
  dispatch: Dispatch,
) => {
  if (error instanceof ApiOperationError) {
    const {operation, entityName} = error;
    dispatch(
      snackRedux.actions.add([
        {
          id: uuidv4(),
          text: t('errors.api.general.operationfailed', {
            operation,
            entityName,
          }),
          timestamp: Date.now(),
          status: 'Error',
          actionTitle: undefined,
        },
      ]),
    );

    return undefined;
  }

  return error;
};
